import React from 'react';

import { TableCell, TableHeaderCell } from '@hcs/design-system';
import { TableCellProps, TableHeaderCellProps } from '@hcs/types';

import { DATA_HC_NAME_ORDER_ITEMS_TABLE_CELL } from '../../constants';
import { OrderItem } from '../../types';
import { ItemIssuesPopover } from '../ItemIssuesPopover';

import { DisplayProps } from '.';

// eslint-disable-next-line react-refresh/only-export-components
const Display = ({ orderItem }: DisplayProps) => {
  return (
    <div data-hc-name={`${DATA_HC_NAME_ORDER_ITEMS_TABLE_CELL}-issues`}>
      {orderItem?.validationChecksComplete ? (
        <ItemIssuesPopover validationResults={orderItem.validationResults} />
      ) : (
        'Validating...'
      )}
    </div>
  );
};

// eslint-disable-next-line react-refresh/only-export-components
const HeaderCell = ({ ...tableHeaderCellProps }) => {
  return <TableHeaderCell {...tableHeaderCellProps}>Issue(s)</TableHeaderCell>;
};

const defaultHeaderCellProps: Partial<TableHeaderCellProps> = {
  isTableHeaderCell: true,
};

HeaderCell.defaultProps = defaultHeaderCellProps;

// eslint-disable-next-line react-refresh/only-export-components
const ContentCell = ({
  orderItem,
  ...tableCellProps
}: {
  orderItem: OrderItem;
}) => {
  return (
    <TableCell {...tableCellProps}>
      <Display orderItem={orderItem} />
    </TableCell>
  );
};

const defaultContentProps: Partial<TableCellProps> = {
  isTableCell: true,
};

ContentCell.defaultProps = defaultContentProps;

export const ORDER_ITEM_ISSUES_CONFIG = {
  HeaderCell,
  ContentCell,
  label: 'Issues',
  sortable: true,
};
